// imports
// classes
import Experience from "./Experience/Experience"


window.experience = new Experience( 
{
    app: document.querySelector( "div.app" ),
    canvas: document.querySelector( "canvas.webgl" )
} )